<template>
    <card id="website-index">
        <div class="row">
            <div class="col-12 col-md-8">
                <h1>{{ event.name }}</h1>
                <!--p>{{ event.description }}</p-->
                 <div v-html="event.description"></div>
            </div>
            <div class="col-12 col-md-4">
                <ul class="list-group">
                    <!-- <li class="list-group-item d-flex align-items-center">
                        <fa :icon="['fas', 'calendar-alt']" size="2x" class="color-primary mr-3"/>
                        {{ event.startDate | date }} - {{ event.endDate | date  }}
                    </li> -->
                    <li class="list-group-item d-flex align-items-center">
                        <fa :icon="['fas', 'envelope']" size="2x" class="color-primary mr-3"/>
                        <a href="mailto:" class="color-black">Contact: {{event.notificationEmail}}</a>
                    </li>
                </ul>
                <br/>
                <ul class="list-group">
                    <li class="list-group-item d-flex align-items-center">                        
                            <router-link :to="{ name: 'website-types' }">
                                <el-button
                                    type="primary"
                                    class="btn btn-primary btn-round">
                                        Register
                                </el-button>
                            </router-link>
                    </li>
                    <li class="list-group-item d-flex align-items-center">                        
                        <el-button 
                            class="btn btn-primary btn-round"
                            @click="confirmationViewRequestDialog = true">
                                <span v-if="!user._id  && event.hideAllPaymentInfoFromRegistrant">View Status</span>
                                <span v-else>Make Payment / View Status</span>
                        </el-button>
                    </li>
                    <li class="list-group-item d-flex align-items-center" v-if="event.showEditMyRegistration">                        
                        <el-button 
                            class="btn btn-primary btn-round"
                            @click="editRegistrationDialog = true">
                            Edit My Registration
                        </el-button>
                    </li>
                </ul>
                
            </div>
            <div class="col-12 mt-5 mb-5">
                <gmap-map
                    v-if="event.location && event.location.lat && event.location.lng && !event.dontShowMapOnConfirmationPage" 
                    :center="event.location"
                    :zoom="7"
                    :options="mapOptions"
                    style="width: 100%; height: 300px">
                        <gmap-marker :position="event.location"/>
                </gmap-map>
            </div>
            <div v-if="speakers && speakers.length" class="col-12">
                <h3 class="text-center">Speakers</h3>
                <div class="row justify-content-around">
                    <div
                        v-for="speaker in speakers"
                        class="col">
                            <div class="d-flex justify-content-center avatar-container">
                                <img
                                    v-if="speaker.picture && speaker.picture._id"
                                    :src="baseUrl + speaker.picture.path"
                                    height="150px"/>
                                <fa
                                    v-else
                                    :icon="['fas', 'user-circle']"/>
                            </div>
                            <h4 class="text-center">{{ speaker.name }} {{ speaker.lastName }}</h4>
                            <p class="text-center">{{ speaker.position }}, {{ speaker.company }}</p>
                    </div>
                </div>
            </div>
            <div class="col-12 text-right">
                <!--el-button 
                    class="btn btn-primary"
                    @click="confirmationViewRequestDialog = true">
                       <span v-if="!user._id  && event.hideAllPaymentInfoFromRegistrant">View Confirmation</span>
                       <span v-else>Make Payment / View Confirmation</span>
                </el-button-->

                <!--el-button v-if="event.showEditMyRegistration"
                    class="btn btn-primary"
                    @click="editRegistrationDialog = true">
                        Edit My Registration
                </el-button-->
            </div>
            <div class="col-12 mb-5">
                <h3 class="text-center">Registration</h3>
                <div class="row justify-content-center">
                    <div class="col-12 col-md-6">
                        <el-table :data="$store.state.types.filter(type => type.publicRegistration && !type.typeGroupOnly)">
                            <el-table-column label="Name" prop="name"/>
                            <el-table-column v-if="user._id || !event.hideAllPaymentInfoFromRegistrant" label="Price" prop="price"/>
                        </el-table>
                        <div class="d-flex justify-content-end">
                            <!-- <el-button
                                class="btn btn-default"
                                @click="confirmationViewRequestDialog = true">
                                    Make Payment / View Confirmation
                            </el-button> -->
                            <!-- <el-button
                                class="btn btn-default ml-0"
                                @click="editRegistrationDialog = true">
                                    Change Registration
                            </el-button> -->
                            <router-link :to="{ name: 'website-types' }">
                                <el-button
                                    type="primary"
                                    class="btn btn-primary btn-round">
                                        Register
                                </el-button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
            title="Edit My Registration"
            :visible.sync="editRegistrationDialog">
                <el-form @submit.prevent.native>
                    <!-- <el-form-item label="Method">
                        <el-radio-group v-model="editRegistrationMethod">
                            <el-radio-button label="email">E-Mail</el-radio-button>
                            <el-radio-button label="id">Id</el-radio-button>
                        </el-radio-group>
                    </el-form-item> -->
                    <el-form-item
                        label="E-Mail">
                            <el-input
                                type="email"
                                v-model="editRegistrationEmail"
                                @keyup.enter.native="getEditRegistrationLink"/>
                    </el-form-item>
                    <el-form-item
                        label="Confirmation Number">
                            <el-input
                                v-model="editRegistrationId"
                                @keyup.enter.native="getEditRegistrationLink"/>
                    </el-form-item>
                    <p class="text-center font-weight-bold font"
                            style="font-size: 12px; color:red">
                                Link to Edit your Registration will be sent to the e-mail id provided.
                    </p>
                    <div class="ql-editor" v-if="event.showEditRegistrationRequestInfo" v-html="event.editRegistrationRequestInfo"></div>
                </el-form>
                <template slot="footer">
                    <el-button
                        type="primary"
                        @click="getEditRegistrationLink()"
                        :loading="sendingLink">
                            Proceed
                    </el-button>
                </template>
        </el-dialog>

        <el-dialog
            title="Make Payment / View Status"
            :visible.sync="confirmationViewRequestDialog">
                <el-form @submit.prevent.native>
                    <el-form-item label="Confirmation Number">
                        <el-input v-model="viewConfirmation.number"/>
                    </el-form-item>
                    <el-form-item label="First Name">
                        <el-input v-model="viewConfirmation.firstName"/>
                    </el-form-item>
                    <el-form-item label="Last Name">
                        <el-input v-model="viewConfirmation.lastName"/>
                    </el-form-item>
                </el-form>
                <div class="d-flex justify-content-end">
                    <el-button
                        type="primary"
                        class="btn btn-primary"
                        :loading="viewRequest"
                        @click="submitConfirmationForCheck()">
                            Proceed
                    </el-button>
                </div>
        </el-dialog>
    </card>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import http from '../../http.js'

export default {
    computed: {
        ...mapState([
            'baseUrl',
            'event',
            'speakers',
            'activities',
            'user'
        ])
    },
    data () {
        return {
            editRegistrationDialog: false,
            confirmationViewRequestDialog: false,
            editRegistrationEmail: '',
            editRegistrationId: '',
            editRegistrationMethod: 'email',
            sendingLink: false,
            viewRequest: false,
            viewConfirmation: {
                _id: '',
                firstName: '',
                lastName: ''
            },
            mapOptions: {
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false
            }
        }
    },
    methods: {
        formatActivityDate: function (activity) {
            let startDate = moment(activity.startDate).format('dddd - MMMM DD HH:mm')
            let endDate = ''
            if (moment(activity.startDate).isSame(activity.endDate, 'day')) {
                endDate = moment(activity.endDate).format('HH:mm')
            } else {
                endDate = moment(activity.endDate).format('dddd - MMMM DD HH:mm')
            }
            return `${startDate} - ${endDate}`
        },
        getEditRegistrationLink: async function () {
            this.sendingLink = true
            try {
                await http.post(`/api/registrations/get-edit-registration-link/${this.editRegistrationMethod}`, {
                    eventId: this.$route.params.eventId,
                    email: this.editRegistrationEmail,
                    registrationId: this.editRegistrationId,
                    host: `${window.location.protocol}//${window.location.host}`
                })

                this.editRegistrationDialog = false
                this.editRegistrationEmail = ''
                this.editRegistrationId = ''
                this.$notify('Information to edit this registration successfully sent to your email.')
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error sending edit registration link')
            }
            this.sendingLink = false
        },
        submitConfirmationForCheck: async function () {
            try {
                const response = await http.get(`/api/registrations/with-confirmation-number/${this.viewConfirmation.number.trim()}/${this.$route.params.eventId}`)
                let firstName = response.data.registration.fields.find(field => field.fieldMapping === 'firstName')
                firstName = firstName ? firstName.value : ''
                let lastName = response.data.registration.fields.find(field => field.fieldMapping === 'lastName')
                lastName = lastName ? lastName.value : ''

                //console.log(firstName, this.viewConfirmation.firstName.toLowerCase().trim() )
                //console.log(lastName, this.viewConfirmation.lastName.toLowerCase().trim() )

                if (firstName.length && firstName.toLowerCase().trim() !== this.viewConfirmation.firstName.toLowerCase().trim()) {
                    this.$notify({ type: 'danger', message: 'Confirmation not found!' })
                    return
                }
                
                if (lastName.length && lastName.toLowerCase().trim() !== this.viewConfirmation.lastName.toLowerCase().trim()) {
                    this.$notify({ type: 'danger', message: 'Confirmation not found!' })
                    return
                }
                
                this.$router.push({ name: 'welcome-email', params: { registrationId: response.data.registration._id } })
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error on viewConfirmation')
            }
        }
    },
    filters: {
        date: (value) => moment(value).format('MMMM DD, YYYY HH:mm')
    }
};
</script>

<style lang="sass">
    #website-index
        h4, p
            margin: 0

        .avatar-container
            font-size: 150px

            img
                height: 150px
                width: 150px
                object-fit: cover
                border-radius: 1000px
</style>